import Experiment from '@mc/experiments-react'
import { TrackingRow } from 'pages/certificates/components'
import { HeroSection } from 'pages/certificates/components/MarketingCertPage'
import { HeroVariant1, HeroVariant2 } from './HeroVariants'
import { MCCERTS_2548_SUBSCRIPTIONS_ENTRY_POINT_FLAG } from './constants'
import { type HeroVariantProps } from './types'
import { useIsSubscriptionsExpEligible } from './utils/useIsSubscriptionsExpEligible'
import { HeroVariant3 } from './variant_3/HeroVariant3'

const ControlHero = (props: HeroVariantProps) => (
  <TrackingRow
    row_name='hero'
    location='hero'
    product_name={props.product?.name}
  >
    <HeroSection {...props} />
  </TrackingRow>
)

// Excluded states from the experiment (coming-soon (emailCapture) and pre-enrolled (notice), defined in useIsSubscriptionsExpEligible) render HeroSection with no <Experiment> (no exposure).
// HeroVariant3 already handles these cases (it mirrors HeroSection),
// but HeroVariant1 and HeroVariant2 don't, so if this experiment is productized add these cases to the winning HeroVariant
export const CMHeroSectionSubsExp = (props: HeroVariantProps) => {
  const isEligible = useIsSubscriptionsExpEligible(props)
  if (!isEligible) {
    return <ControlHero {...props} />
  }

  return (
    <Experiment<HeroVariantProps>
      {...props}
      name={MCCERTS_2548_SUBSCRIPTIONS_ENTRY_POINT_FLAG}
      default={ControlHero}
      variant_1={HeroVariant1}
      variant_2={HeroVariant2}
      variant_3={HeroVariant3}
    />
  )
}
